<div class="nb-page-header">
  <div>
    <span class="title">{{ task?.processTitle }}</span>
  </div>
  <div>
    <button nz-button nzType="default" (click)="goBack()">返回</button>
  </div>
</div>
<div class="full-panel">
  <!--  <div class="right-panel">-->
  <nz-card class="container" style="width: 76%; margin-right: 10px">
    <nz-card-tab>
      <nz-tabset *ngIf="forms" [(nzSelectedIndex)]="index" (nzSelectedIndexChange)="changeIndex($event)">
        <nz-tab *ngFor="let t of forms" [nzTitle]="t.displayName"></nz-tab>
        <!--        <nz-tab nzTitle="审批信息"></nz-tab>-->
      </nz-tabset>
    </nz-card-tab>
    <div [style.display]="isFormVisible" class="apply-info-content">
      <nb-form-viewer
        [formGroup]="currentGroup"
        [form]="currentForm"
        [data]="currentData"
        [readonly]="true"
        [downloadUrl]="downloadUrl"
        [importUrl]="importUrl"
        [uploadUrl]="uploadUrl"
        [token]="token"
        [pdfUrl]="pdfUrl"
      ></nb-form-viewer>
    </div>
  </nz-card>
  <!--  </div>-->

  <div class="left-panel">
    <h1 class="title">{{ ticket.nodeName }}</h1>
    <!--    <div class="audit-tip-box"><div class="audit-tip">未提交</div></div>-->
    <nz-card *ngIf="meta" nzBorderless nzSize="small" class="indicator-card" [nzTitle]="meta.displayName">
      <div class="applicant">
        <sv-container [col]="1">
          <ng-container *ngIf="meta && meta.fields">
            <sv *ngFor="let mt of meta.fields" [label]="mt.title">{{ explainMeta(mt) }}</sv>
          </ng-container>
        </sv-container>
      </div>
      <div class="nb-divider"></div>
    </nz-card>

    <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="抄送信息">
      <div class="make-copy-frame">
        <div class="copy-each" *ngFor="let op of task?.ccUsers">
          <div class="copy-img-box">
            <div class="bg-img">
              <img
                class="copy-img"
                [src]="userMap[op] && userMap[op].avatar ? downLoad + userMap[op].avatar : '../../../../assets/picture/init-img.png'"
                alt=" "
              />
            </div>
          </div>
          <div>{{ userMap[op] ? userMap[op].name : '-' }}</div>
        </div>
      </div>
      <div class="nb-divider"></div>
    </nz-card>
    <!--    <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="抄送信息">-->
    <!--      <sv-container [col]="1" class="applicant">-->
    <!--        <sv label="抄送职能"><nz-tag *ngFor="let op of task?.processCcRoles" [nzColor]="'blue'">{{roleMap[op]? roleMap[op].name : '-'}}</nz-tag></sv>-->
    <!--        <sv label="抄送员工"><nz-tag *ngFor="let op of task?.processCcUsers" [nzColor]="'purple'">{{userMap[op]? userMap[op].name : '-'}}</nz-tag></sv>-->
    <!--        <sv label="追加抄送"><nz-tag *ngFor="let op of task?.ccUsers" [nzColor]="'volcano'">{{userMap[op]? userMap[op].name : '-'}}</nz-tag></sv>-->
    <!--      </sv-container>-->
    <!--      <div class="nb-divider"></div>-->
    <!--    </nz-card>-->

    <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="审核信息">
      <div>
        <div *ngFor="let op of history; let i = index" class="audit-each">
          <div class="left-time">{{ op.date }}</div>
          <div class="right-info">
            <div class="title" style="cursor: pointer" (click)="onNodeView(op)">
              <img
                *ngIf="!op.isCurrent && (i == 0 || i == history.length - 1)"
                class="title-left-img"
                src="../../../../assets/picture/audit-start.png"
                alt="icon"
              />
              <img
                *ngIf="op.routeName == '驳回' || op.routeName == '关闭'"
                class="title-left-img"
                src="../../../../assets/picture/audit-refuse.png"
                alt="icon"
              />
              <img
                *ngIf="!op.isCurrent && i != 0 && i != history.length - 1 && op.routeName != '驳回' && op.routeName != '关闭'"
                class="title-left-img"
                src="../../../../assets/picture/audit-agree.png"
                alt="icon"
              />
              <img
                *ngIf="op.isCurrent && op.taskStatus != 2 && op.taskStatus != 3"
                class="title-left-img"
                src="../../../../assets/picture/await.png"
                alt="icon"
              />
              <img
                *ngIf="op.isCurrent && (op.taskStatus == 2 || op.taskStatus == 3) && i == history.length - 1"
                class="title-left-img"
                src="../../../../assets/picture/audit-start.png"
                alt="icon"
              />
              {{ op.nodeName }}
            </div>
            <div *ngIf="!op.isCurrent" class="detail-info" [style]="i == history.length - 1 ? { 'border-left': 'none' } : ''">
              <div *ngIf="op.operatorName && op.routeName" class="des">
                {{ op.operatorName
                }}<span [ngClass]="op.routeName == '驳回' || op.routeName == '关闭' ? 'audit-detail disagree' : 'audit-detail agree'">{{
                  op.routeName
                }}</span>
                任务
              </div>
              <div *ngIf="op.comment" class="comment">{{ op.comment }}</div>
              <div *ngIf="op.singImg" class="sign">查看签字 <img class="sign-img" [src]="op.singImg" alt="icon" /></div>
            </div>
            <div
              *ngIf="op.isCurrent && op.taskStatus != 2 && op.taskStatus != 3"
              class="detail-info"
              [style]="i == history.length - 1 ? { 'border-left': 'none' } : ''"
            >
              <div class="deal">等待处理</div>
            </div>
          </div>
        </div>
      </div>
      <div class="nb-divider"></div>
    </nz-card>
  </div>
</div>

<!--查看节点信息-->
<app-node-view
  *ngIf="showViewModal"
  [id]="ticketId"
  [auditInfo]="auditInfo"
  [isVisible]="showViewModal"
  (isVisibleChange)="isViewNodeVisibleChange($event)"
>
</app-node-view>
